import { getClosestNumberArrayUtil, omitObjectUtil } from 'packages/src'
import {
  COUNT_KEY_TO_VALUES,
  SET_DATA_COUNT_UNIT_KEYS,
  SET_DATA_KEY
} from '../../constants'
import {
  getDurationFromRepsSetDataUtil,
  getRepsFromDurationSetDataUtil
} from '../get-set-duration'

export function updateCountKeySetDataUtil (set, key) {
  let newSet = omitObjectUtil(set || {}, SET_DATA_COUNT_UNIT_KEYS)

  const reps = set[SET_DATA_KEY.REPS]
  const timeOrRest = set[SET_DATA_KEY.TIME] || set[SET_DATA_KEY.REST]
  if (reps != null && key !== SET_DATA_KEY.REPS) {
    // From reps to time
    const duration = getDurationFromRepsSetDataUtil(reps)
    newSet[key] = getClosestNumberArrayUtil(COUNT_KEY_TO_VALUES[SET_DATA_KEY.TIME],
      duration
    )
  } else if (reps == null && key === SET_DATA_KEY.REPS) {
    // From time/rest to reps
    newSet[key] = getRepsFromDurationSetDataUtil(timeOrRest)
  } else if ([
    SET_DATA_KEY.TIME,
    SET_DATA_KEY.REST
  ].includes(key)) {
    // From time to rest or vice versa
    newSet[key] = timeOrRest
  }

  // let timeValue
  // if ([
  //   SET_DATA_KEY.TIME,
  //   SET_DATA_KEY.REST
  // ].includes(key)) {
  //   timeValue = (
  //     set[SET_DATA_KEY.TIME] ||
  //     set[SET_DATA_KEY.REST]
  //   )
  // }
  // newSet[key] = timeValue || COUNT_KEY_TO_VALUES[key][0]

  if (key === SET_DATA_KEY.REST) {
    newSet = omitObjectUtil(newSet, [
      SET_DATA_KEY.WEIGHT,
      SET_DATA_KEY.WEIGHT_UNIT
    ])
  }

  return newSet
}
